import React from "react"
import { Grid, IconButton } from "@material-ui/core"
import { Email } from "@material-ui/icons"
import { StaticQuery, graphql } from "gatsby"
import PrismicRichText from "../utils/PrismicRichText"
import {
  Facebook,
  Instagram,
  Twitter,
  Pinterest,
  LinkedIn,
  Reddit,
  YouTube,
} from "@material-ui/icons"
//
//

const ContactSection = () => {
  const query = graphql`
    query GeneralInfo {
      prismic {
        allGeneral_infos {
          edges {
            node {
              phone_number
              email_address
              contact_text
              links {
                socialtype
                link_target {
                  ... on PRISMIC__ExternalLink {
                    _linkType
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  `
  return (
    <StaticQuery query={`${query}`}>
      {data => {
        const contactInfo = data.prismic.allGeneral_infos.edges[0].node
        const { email_address, contact_text, links } = contactInfo
        return (
          <Grid container justify="space-around" style={{ zIndex: 5 }}>
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <PrismicRichText text={contact_text} />
            </Grid>

            {links && links.length && (
              <Grid
                item
                xs={12}
                sm="auto"
                style={{ display: "flex", justifyContent: "space-around" }}
              >
                <a
                  href={`mailto:${email_address}?subject=From Website`}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <IconButton style={{ margin: "5px" }}>
                    <Email style={{ color: "white" }} />
                  </IconButton>
                </a>
                {links.map((link, index) => {
                  return <LinkDisplay key={index} link={link} />
                })}
              </Grid>
            )}
          </Grid>
        )
      }}
    </StaticQuery>
  )
}

export default ContactSection

const LinkDisplay = ({ link }) => {
  const {
    socialtype,
    link_target: { url },
  } = link
  const icons = {
    Facebook,
    Instagram,
    Twitter,
    Pinterest,
    LinkedIn,
    Reddit,
    YouTube,
  }
  const Icon = icons[socialtype]
  return (
    <a href={url} style={{ textDecoration: "none" }}>
      <IconButton style={{ margin: "5px" }}>
        <Icon style={{ color: "white" }} />
      </IconButton>
    </a>
  )
}
